import { Configuration } from '@rbx/clients';
import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import { getBEDEV2ServiceBasePath, getRobloxDomain } from '@modules/utilities/constants/baseUrl';
import {
  CreatorSettingsAPIApi,
  GenericCreatorSettingType,
  GetGenericCreatorSettingsByUserIdAndSettingTypeResponse,
  V2SettingsUserUserIdSettingSettingTypePatchRequest,
  UpdateOrCreateGenericCreatorSettingsByUserIdAndSettingTypeResponse,
} from '@rbx/clients/creatorSettings';

export class CreatorSettingsClient {
  private creatorSettingsApi: CreatorSettingsAPIApi;

  constructor(basePath: string = getBEDEV2ServiceBasePath('creator-settings')) {
    const configuration = new Configuration({
      robloxSiteDomain: getRobloxDomain(),
      basePath,
      credentials: 'include',
      unifiedLogger: unifiedLoggerClient,
    });

    this.creatorSettingsApi = new CreatorSettingsAPIApi(configuration);
  }

  getGenericCreatorSetting(
    userId: number,
    settingType: GenericCreatorSettingType,
  ): Promise<GetGenericCreatorSettingsByUserIdAndSettingTypeResponse> {
    const v2SettingsUserUserIdSettingSettingTypeGetRequest = {
      userId,
      settingType,
    };
    return this.creatorSettingsApi.v2SettingsUserUserIdSettingSettingTypeGet(
      v2SettingsUserUserIdSettingSettingTypeGetRequest,
    );
  }

  updateGenericCreatorSetting(
    userId: number,
    settingType: GenericCreatorSettingType,
    settingValue: string,
  ): Promise<UpdateOrCreateGenericCreatorSettingsByUserIdAndSettingTypeResponse> {
    const v2SettingsUserUserIdSettingSettingTypePatchRequest: V2SettingsUserUserIdSettingSettingTypePatchRequest =
      {
        userId,
        settingType,
        updateOrCreateGenericCreatorSettingsByUserIdAndSettingTypeRequest: {
          settingValue,
        },
      };
    return this.creatorSettingsApi.v2SettingsUserUserIdSettingSettingTypePatch(
      v2SettingsUserUserIdSettingSettingTypePatchRequest,
    );
  }
}

const creatorSettingsClient = new CreatorSettingsClient();

export default creatorSettingsClient;
